import { useTranslation } from "react-i18next";
import useMasteryPage from "./hooks/useMasteryPage";
import PageContainer from "../../components/PageContainer";
import ProgressLine from "../progress/ProgressLine";

const MasteryPage = () => {
  const { t } = useTranslation();
  const { mastery, masteryLoading } = useMasteryPage();
  return (
    <PageContainer header={t("page.mastery")} isLoading={masteryLoading}>
      <div style={{ width: "100%" }}>
        {mastery?.map((masteryLine) => (
          <ProgressLine key={masteryLine?.topic?.id} {...masteryLine} />
        ))}
      </div>
    </PageContainer>
  );
};

export default MasteryPage;
